import { usePostHog } from 'posthog-js/react'
import { useCallback } from 'react'

import { isDev } from '../config'
import { trackAmplitudeEvent } from './amplitude'

const debugLog = (
  eventName: string,
  properties: Record<string, string | number | boolean>,
) => {
  console.info(`[Analytics] ${eventName}:`, properties)
}

export const useCaptureEvent = () => {
  const posthog = usePostHog()

  const capture = useCallback(
    (
      eventName: string,
      properties: Record<string, string | number | boolean>,
    ) => {
      posthog?.capture(eventName, properties)
      trackAmplitudeEvent(eventName, properties)
    },
    [posthog],
  )

  if (isDev) {
    return debugLog
  }
  return capture
}
